import {
    REPORT_REQUEST,
  } from "../actions/utilities";

const INITIAL_STATE = {
    getMonthlySummaryProjectsReportLoading: false,
    getMonthlySummaryProjectsReportSuccess: false,
    getMonthlySummaryProjectsReportFailure: false,
    getMonthlySummaryProjectsReportError: null,
    getMonthlySummaryProjectsReportData: [],

    getMonthlySummaryUsersReportLoading: false,
    getMonthlySummaryUsersReportSuccess: false,
    getMonthlySummaryUsersReportFailure: false,
    getMonthlySummaryUsersReportError: null,
    getMonthlySummaryUsersReportData: [],
  };

  export const reportReducer = (state = INITIAL_STATE, action) => {
    switch (action.type) {
      case REPORT_REQUEST.GET_MONTHLY_SUMMARY_PROJECTS_REPORT_REQUEST:
        return {
          ...state,
          getMonthlySummaryProjectsReportLoading: true,
          getMonthlySummaryProjectsReportSuccess: false,
          getMonthlySummaryProjectsReportFailure: false,
          getMonthlySummaryProjectsReportError: null,
        };
      case REPORT_REQUEST.GET_MONTHLY_SUMMARY_PROJECTS_REPORT_SUCCESS:
        return {
          ...state,
          getMonthlySummaryProjectsReportLoading: false,
          getMonthlySummaryProjectsReportSuccess: true,
          getMonthlySummaryProjectsReportFailure: false,
          getMonthlySummaryProjectsReportError: null,
          getMonthlySummaryProjectsReportData: action.payload,
        };
      case REPORT_REQUEST.GET_MONTHLY_SUMMARY_PROJECTS_REPORT_FAILURE:
        return {
          ...state,
          getMonthlySummaryProjectsReportLoading: false,
          getMonthlySummaryProjectsReportSuccess: false,
          getMonthlySummaryProjectsReportFailure: true,
          getMonthlySummaryProjectsReportError: action.payload,
        };
      case REPORT_REQUEST.GET_MONTHLY_SUMMARY_USERS_REPORT_REQUEST:
        return {
          ...state,
          getMonthlySummaryUsersReportLoading: true,
          getMonthlySummaryUsersReportSuccess: false,
          getMonthlySummaryUsersReportFailure: false,
          getMonthlySummaryUsersReportError: null,
        };
      case REPORT_REQUEST.GET_MONTHLY_SUMMARY_USERS_REPORT_SUCCESS:
        return {
          ...state,
          getMonthlySummaryUsersReportLoading: false,
          getMonthlySummaryUsersReportSuccess: true,
          getMonthlySummaryUsersReportFailure: false,
          getMonthlySummaryUsersReportError: null,
          getMonthlySummaryUsersReportData: action.payload,
        };
      case REPORT_REQUEST.GET_MONTHLY_SUMMARY_USERS_REPORT_FAILURE:
        return {
          ...state,
          getMonthlySummaryUsersReportLoading: false,
          getMonthlySummaryUsersReportSuccess: false,
          getMonthlySummaryUsersReportFailure: true,
          getMonthlySummaryUsersReportError: action.payload,
        };
      default:
        return state;
    }
  }